var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurVisionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7426 28.5751L18.5326 30.1128C18.2527 30.1735 17.9602 30.1217 17.7183 29.9684C17.4764 29.8151 17.3045 29.5728 17.2399 29.2938L16.6134 26.7855C16.5397 26.4833 16.5816 26.1644 16.7307 25.8914C16.8798 25.6185 17.1255 25.411 17.4196 25.3096L33.1742 20.1296",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8199 27.7048L34.8739 26.6268",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 38.5L29.0442 31.255",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2326 20.93C33.0826 20.3297 33.1772 19.6944 33.4955 19.1639C33.8138 18.6334 34.3298 18.251 34.9301 18.1008L36.2017 17.7835C36.5017 17.7086 36.8191 17.7559 37.0842 17.915C37.3494 18.074 37.5405 18.3318 37.6157 18.6316L39.3832 25.7016C39.4584 26.0018 39.4113 26.3195 39.2522 26.5849C39.0932 26.8503 38.8352 27.0416 38.5351 27.1168L37.2634 27.4341C36.6631 27.5841 36.0279 27.4895 35.4973 27.1712C34.9668 26.8529 34.5844 26.3369 34.4342 25.7366L33.2326 20.93Z",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1843 24.0718L22.484 29.2704",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 38.5L26.9559 31.255",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31.5C29.2886 31.5 30.3333 30.4554 30.3333 29.1667C30.3333 27.878 29.2886 26.8334 28 26.8334C26.7113 26.8334 25.6666 27.878 25.6666 29.1667C25.6666 30.4554 26.7113 31.5 28 31.5Z",
    stroke: "#057DCD",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVisionIcon);
export default __webpack_public_path__ + "static/media/our-vision-icon.32c1a69268c5bf1b5c7c02240c222486.svg";
export { ForwardRef as ReactComponent };